import type { ReactNode } from 'react';

export type Tone = 'gray' | 'primary' | 'green' | 'amber' | 'red' | 'magenta' | 'cyan';

const TONE_CLASS: Record<Tone, string> = {
  gray: '',
  primary: 'pri',
  green: 'grn',
  amber: 'amb',
  red: 'rd',
  magenta: 'mag',
  cyan: 'cy',
};

export function Pill({
  tone = 'gray',
  children,
  dot = true,
  className,
}: {
  tone?: Tone;
  children: ReactNode;
  dot?: boolean;
  className?: string;
}) {
  return (
    <span className={`pill ${TONE_CLASS[tone]} ${className ?? ''}`.trim()}>
      {dot && <span className="dot" />}
      {children}
    </span>
  );
}

export function SrcTag({
  tone,
  children,
}: { tone?: 'pri' | 'grn' | 'amb' | 'rd' | 'mag'; children: ReactNode }) {
  return <span className={`src-tag${tone ? ` ${tone}` : ''}`}>{children}</span>;
}
